export default __webpack_public_path__ + "static/media/smartphone-with-earphones.68c25f8d.jpg";